import { ErrorHandler, Injectable } from '@angular/core';
import { ApiException } from '@data-access/bulk-operations-api';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: Error): void {
    if (error?.message?.includes('Failed to fetch dynamically imported module')) {
      console.warn('Dynamic import error:', error);
      window.location.reload();
      return;
    }

    if (ApiException.isApiException(error)) {
      return;
    }

    throw error;
  }
}
